import { AxiosError } from 'axios';
import { HTTPError } from 'ky';

type ErrorData = {
  message: string | string[];
};

export const getKyErrorMessage = async(error: unknown): Promise<string> => {
  const err = error as HTTPError | Error;
  const { message } = err instanceof HTTPError ? await err.response.json() : (err as Error);

  return message;
};

export const getErrorMessage = (error: unknown): string => {
  if (!(error instanceof AxiosError)) {
    return String(error);
  }

  const { data } = error.response || {};

  if (typeof data === 'string') {
    const { message }: ErrorData = JSON.parse(data);

    return Array.isArray(message) ? message.join(', ') : message;
  }

  if ('message' in data) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return data.message;
  }

  return error.message;
};
